export default __webpack_public_path__ + "static/media/cookies.0be4d9a0.png";